import { AdTemplate } from 'models/AdTemplate';
import { Ad } from 'components/Ad';
import { SliderAd as SliderAdModel } from 'models/SliderAd';
import styles from './styles.scss';
import { AppearanceTypes } from 'components/Shared/Layout/base';
import cn from 'classnames';

export interface CarouselAdProps extends SliderAdModel {
  gotoOfferText: string;
  appearance?: AppearanceTypes;
  position: number;
}

const NoComponent = () => {
  return <div>No component</div>;
};

const AdComponent: { [key: number]: (props: CarouselAdProps) => JSX.Element } = {
  [AdTemplate.PanoramaTwoThirds]: ({ position, ...props }) => (
    <Ad
      ad={props}
      gotoOfferText={props.gotoOfferText}
      position={position}
      className={cn({
        [styles.secondary]: props.appearance === 'secondary'
      })}
    />
  ),
  [AdTemplate.PanoramaFull]: props => <Ad ad={props} />,
  [AdTemplate.PanoramaBrandContent]: props => <Ad ad={props} />,
  [AdTemplate.SiteWide]: props => (
    <Ad
      ad={props}
      gotoOfferText={props.gotoOfferText}
      position={props.position}
      className={cn({
        [styles.secondary]: props.appearance === 'secondary'
      })}
    />
  )
};

export default (props: CarouselAdProps) => {
  const Component = AdComponent[props.adTemplate] || NoComponent;
  return <Component {...props} />;
};
